import {styled} from '@mui/material';

export const CardsContainer = styled('div')(({ theme, posts }) => ({
  display: posts ? 'grid' : 'flex',
  gridTemplateColumns: posts ? 'repeat(4, 1fr)' : undefined,
  gridGap: posts ? '20px 30px' : undefined,
  justifyContent: posts ? undefined : 'center',
  [theme.breakpoints.down(1100)]: {
    gridTemplateColumns: posts ? 'repeat(3, 1fr)' : undefined,
  },
  [theme.breakpoints.down('md')]: {
    gridTemplateColumns: posts ? 'repeat(2, 1fr)' : undefined,
  },
  [theme.breakpoints.down(500)]: {
    gridTemplateColumns: posts ? '1fr' : undefined,
  },
}));
